module.exports = __webpack_public_path__ + "assets/img/ca-square.b0319ce8.jpg";